export default function JobNavIco({ color }) {
  return (
    <svg
      width="22"
      height="18"
      viewBox="0 0 22 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.3545 6.41792H20.6455M8.96936 1L6.93873 6.41792L11 16.8023L15.0612 6.41792L13.0306 1M11.624 16.5878L20.7198 6.88039C20.874 6.71586 20.9511 6.6336 20.9805 6.54178C21.0065 6.46082 21.0065 6.37502 20.9805 6.29406C20.9511 6.20223 20.874 6.11998 20.7198 5.95546L16.3201 1.25992C16.2306 1.16438 16.1859 1.11661 16.131 1.08227C16.0823 1.05184 16.0281 1.02924 15.9707 1.0155C15.9059 1 15.836 1 15.6961 1H6.30385C6.164 1 6.09409 1 6.02929 1.0155C5.97189 1.02924 5.91764 1.05184 5.86901 1.08227C5.81415 1.11661 5.76938 1.16438 5.67986 1.25992L1.28016 5.95546C1.12601 6.11997 1.04893 6.20223 1.01947 6.29406C0.99351 6.37502 0.99351 6.46082 1.01947 6.54177C1.04893 6.6336 1.12601 6.71586 1.28016 6.88039L10.376 16.5878C10.5903 16.8165 10.6974 16.9309 10.8257 16.9726C10.9382 17.0091 11.0617 17.0091 11.1743 16.9726C11.3025 16.9309 11.4097 16.8165 11.624 16.5878Z"
        stroke="#0070F2"
        stroke-width="1.7"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}
